import axios from '../config/api'

const state = () => ({
  order: null,
  availableBranchTimes: [],
  availablePaymentGateways: [],
  isLoading: false,
  isError: false,
  errorMessage: '',
})

// getters
const getters = {
  order: state => state.order,
  availableBranchTimes: state => state.availableBranchTimes,
  getVipPaymentMethods: state => state.availablePaymentGateways ?? [],
  isLoading: state => state.isLoading,
  isError: state => state.isError,
}

// actions
const actions = {
  async getVipPayment({ commit }, uuid) {
    commit('getVipPaymentRequest')

    await axios
      .get(`/vip-payment/${uuid}`)
      .then(response => {
        commit('getVipPaymentSuccess', response.data.data)
      })
      .catch(error => {
        commit('getVipPaymentFailure', error?.response?.data?.message)
      })
  },
}

// mutations
const mutations = {
  getVipPaymentRequest(state) {
    state.isLoading = true
    state.isError = false
    state.errorMessage = ''
  },
  getVipPaymentSuccess(state, payload) {
    state.isLoading = false
    state.order = payload.order
    state.availableBranchTimes = payload.available_branch_times ?? []
    state.availablePaymentGateways =
      payload.available_payment_gateways ?? []
  },
  getVipPaymentFailure(state, errorMessage) {
    state.isLoading = false
    state.isError = true
    state.errorMessage =
      errorMessage || 'เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง'
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
